import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./pages/Login";

import Dashboard from "./pages/Dashboard";
import PrivateRoute from "./components/routes/PrivateRoute";
import ManageDashboard from "./pages/ManageDashboard";


const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<Login />} />

        {/* Private Route */}
        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/manage-dashboard" element={<ManageDashboard />} />
          <Route path="*" element={<Dashboard />} />
        </Route>
        
      </Routes>
    </Router>
  );
};

export default App;